/**
 * Raspoznavanje YouTube linkova. Korisnik ga zalijepi u bilo kojem obliku — `watch?v=`,
 * `youtu.be`, `embed` ili `shorts` — a oglas iz njega treba i player i sličicu.
 */

const YOUTUBE_PATH_PREFIXES = ["embed", "shorts", "live", "v"];

/** Id videa, ili `null` kad link nije YouTube ili se id ne da pročitati. */
export const getYoutubeVideoId = (url: string): string | null => {
  if (!url?.trim()) return null;

  try {
    const parsed = new URL(url.trim());

    if (parsed.hostname === "youtu.be") {
      return parsed.pathname.split("/").filter(Boolean)[0] ?? null;
    }

    if (!parsed.hostname.includes("youtube.com")) return null;

    const fromQuery = parsed.searchParams.get("v");
    if (fromQuery) return fromQuery;

    const [prefix, id] = parsed.pathname.split("/").filter(Boolean);

    return YOUTUBE_PATH_PREFIXES.includes(prefix) && id ? id : null;
  } catch {
    // Nije valjan URL — korisnik je upisao slobodan tekst.
    return null;
  }
};

export const getYoutubeEmbedUrl = (url: string): string | null => {
  const id = getYoutubeVideoId(url);

  return id ? `https://www.youtube.com/embed/${id}` : null;
};

/**
 * Sličica videa. `hqdefault` postoji za svaki video, dok `maxresdefault` ima samo dio njih
 * — a promašaj vraća sivu zamjensku sliku, što bi u galeriji izgledalo kao greška.
 */
export const getYoutubeThumbnailUrl = (url: string): string | null => {
  const id = getYoutubeVideoId(url);

  return id ? `https://img.youtube.com/vi/${id}/hqdefault.jpg` : null;
};
